export default __webpack_public_path__ + "static/media/coding.c4cf1417.png";